import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '../widgets/IconButton';
import ActionDelete from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ViewIcon from '@material-ui/icons/Pageview';
import PersistedDataTable from '../widgets/persistedDataTable';

const HelpPagesGrid = ({ 
	helpPages, canEdit, canView, onEditHelpPage, onDeleteHelpPage, onViewHelpPage
}) => {
	const columns = [
		{ name: 'name', label: 'Name' },
		{ name: 'pageUrl', label: 'pageUrl' },
		{ name: 'isActive', label: 'Is Active', dataType: 'bool' }
	];

	if (canEdit) {
		columns.splice(0, 0, {
			name: 'commands',
			excludeFromSearch: true,
			excludeFromFilter: true,
			cellRenderer: (args) => 
				<div style={{ whiteSpace: 'nowrap' }}>
					<IconButton onClick={ () => { onEditHelpPage(args.data); } } style={{ padding: '2px' }}>
						<EditIcon />
					</IconButton>
					<IconButton onClick={ () => { onDeleteHelpPage(args.data); } } style={{ padding: '2px' }}>
						<ActionDelete />
					</IconButton>
				</div>
		});
	} else if (canView) {	
		columns.splice(0, 0, {
			name: 'commands',
			excludeFromSearch: true,
			excludeFromFilter: true,
			cellRenderer: (args) => 
				<div style={{ whiteSpace: 'nowrap' }}>
					<IconButton onClick={ () => { onViewHelpPage(args.data); } } style={{ padding: '2px' }}>
						<ViewIcon />
					</IconButton>
				</div>
		});
	}

	return (
		<PersistedDataTable 
			id="helpPages"
			data={helpPages || []} 
			columns={columns}
		/>
	);
};

HelpPagesGrid.propTypes = {
	helpPages: PropTypes.array.isRequired,
	canView: PropTypes.bool.isRequired,
	canEdit: PropTypes.bool.isRequired,
	onEditHelpPage: PropTypes.func.isRequired,
	onViewHelpPage: PropTypes.func.isRequired,
	onDeleteHelpPage: PropTypes.func.isRequired
};

export default HelpPagesGrid;
